export enum CopyBlockDisplayType {
	Default = 'Default',
	TravelSection = 'Travel Section',
}
